import type { Faq } from '@/domain/faqs/entities/faq.entity'
import type { Interest } from '@/domain/interests/entities/interest.entity'
import type { NotificationListItem } from '@/domain/notifications/entities/notification_list_item.entity'
import type { Post } from '@/domain/posts/entities/post.entity'
import type { ReportedPost } from '@/domain/reports/entities/reported_post.entity'
import type { UserListItem } from '@/domain/users/entities/user.entity'

export function matchPushRecipient(user: UserListItem, term: string): boolean {
  return [user.name, user.email, user.phoneNo].some(field => field.toLowerCase().includes(term))
}

export function matchInterest(interest: Interest, term: string): boolean {
  return interest.name.toLowerCase().includes(term)
}

export function matchFaq(faq: Faq, term: string): boolean {
  return [faq.question, faq.answer].some(field => field.toLowerCase().includes(term))
}

export function matchUserListItem(user: UserListItem, term: string): boolean {
  return (
    user.name.toLowerCase().includes(term) ||
    user.email.toLowerCase().includes(term) ||
    user.phoneNo.includes(term)
  )
}

export function matchPost(post: Post, term: string): boolean {
  return [post.content, post.postedBy].some(field => field.toLowerCase().includes(term))
}

export function matchReportedPost(post: ReportedPost, term: string): boolean {
  return [post.content, post.postedBy, post.reportedBy, post.reason].some(field =>
    field.toLowerCase().includes(term)
  )
}

export function matchNotification(item: NotificationListItem, term: string): boolean {
  return [item.senderName, item.receiverName, item.title, item.message].some(field =>
    field.toLowerCase().includes(term)
  )
}
